import * as React from "react";
import "./App.css";
import NavBarLayout from "./NavbarLayout";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { buttonStyle } from "./colors";
import Outfit19 from "./outfits/outfit 19.png";
import Outfit18 from "./outfits/outfit 18.png";
import Outfit17 from "./outfits/outfit 17.png";
import { LuRefreshCw } from "react-icons/lu";
import { IoMdCheckmark } from "react-icons/io";

const AUTO_OUTFITS = [Outfit17, Outfit18, Outfit19];
const AUTO_OUTFITS_DESC = [
  "A brown checkered shirt dress with collars",
  "A black crop top paired with a skirt and blazer. The skirt and blazer share the same brown colored fabric",
  "A white tshirt paired with a skirt and blazer. The skirt and blazer share the same gray checkered fabric",
];

function Autogenerate() {
  const navigate = useNavigate();
  const [outfitIndex, setOutfitIndex] = React.useState(0);

  return (
    <NavBarLayout
      title="Generate #OOTD"
      onBackButtonClicked={() => navigate("/outfitmethods")}
      active={0}
    >
      <div className="Autogenerate-outerContainer">
        <div className="Autogenerate-container">
          <div className="eventLabel">Event: Work Day</div>
          <div className="Autogenerate-imageContainer">
            <img
              style={{ height: "50vh" }}
              src={AUTO_OUTFITS[outfitIndex]}
              alt={AUTO_OUTFITS_DESC[outfitIndex]}
            ></img>
          </div>
          <div className="Autogenerate-buttonContainer">
            <Button
              onClick={() =>
                setOutfitIndex((outfitIndex + 1) % AUTO_OUTFITS.length)
              }
              sx={{ ...buttonStyle }}
              variant="contained"
            >
              <span className="Autogenerate-buttonText">Regenerate</span>
              <LuRefreshCw />
            </Button>
            <Button
              onClick={() => {
                sessionStorage.setItem("outfitIndex", outfitIndex);
                sessionStorage.setItem("method", "autogenerate");
                navigate("/home");
              }}
              sx={{ ...buttonStyle }}
              variant="contained"
            >
              <span className="Autogenerate-buttonText">Confirm</span>
              <IoMdCheckmark />
            </Button>
          </div>
        </div>
      </div>
    </NavBarLayout>
  );
}

export default Autogenerate;
